export default __webpack_public_path__ + "img/fg-3.bd75d52e051f7784a16181fa4523299d.png";